export const topAnimeNumberColour: Record<number, string> = {
  1: "#e78383",
  2: "#5e5eb5",
  3: "#c7c467"
};
